import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=6faa56e4&scoped=true"
import script from "./ShareModal.vue?vue&type=script&lang=js"
export * from "./ShareModal.vue?vue&type=script&lang=js"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=6faa56e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa56e4",
  null
  
)

export default component.exports